Vue.component('ack-personalized-training', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-personalized-training',
    mixins: [languageMixins],
    created() {

    },
    mounted() {
      appLog.log('ack-personalized-training mounted')
      this.setPageIsLoading(false)
      this.redirectToHomePage()
    },
    props:{

    },
    computed: {
      ...Vuex.mapGetters('shop', ['currentCurrency', 'currentCurrencySymbol', 'currentCountryCode']),
      isMobile(){
        return this.$parent.isMobile
      },

      productIsNotAvailableInRegion(){
        let notAvailable = false
        if(( this.currentCountryCode.toUpperCase() == 'US' || this.currentCountryCode.toUpperCase() == 'CA' )){
          notAvailable = true
        }
        return notAvailable
      }
    },
    data() {
      return {
        pageId: 'personalized-training-page',
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading']),
      ...Vuex.mapActions('shop', ['addToCartFromProperties', 'buyNow']),
      //...Vuex.mapActions('sliders', ['getSlideList'])
      onAddToCartOneHourClick(){
        appLog.log('onAddToCartOneHourClick', LOG_TYPE.debug)

        this.addToCartFromProperties({
          productId: 'gid://shopify/Product/4469342699623',
          variantId: 'gid://shopify/ProductVariant/31817648930919',
          sellingPlanId: null
        })
      },
      onAddToCartThreeHourClick(){
        appLog.log('onAddToCartThreeHourClick', LOG_TYPE.debug)

        this.addToCartFromProperties({
          productId: 'gid://shopify/Product/4467244335207',
          variantId: 'gid://shopify/ProductVariant/31809138753639',
          sellingPlanId: null
        })
      },

      onBuyNowOneHourClick(){

        this.buyNow({variantId: 'gid://shopify/ProductVariant/31817648930919'})
          .then((url)=>{
            window.open(url, '_blank')
          })
      },
      onBuyNowThreeHourClick(){
        this.buyNow({variantId: 'gid://shopify/ProductVariant/31809138753639'})
          .then((url)=>{
            window.open(url, '_blank')
          })
      },

      redirectToHomePage(){
        if (this.productIsNotAvailableInRegion) {
          window.location.href = '/'
        }
      }

    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })